module.exports = __webpack_public_path__ + "static/media/browser-edge.bab34486.svg";